import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Plus } from '../../../../../icons';
import { EnhancedAutocomplete } from '../../../../EnhancedAutocomplete';
import { Column, Row } from '../../../../Layout';
import { Typography } from '../../../../Typography';
import { INDICATOR_SIZE } from '../../table.constants';
export function SelectCell(param) {
    let { value, options, emptySearchText, placeholder, disabled, disableClearable, virtualizeOptions, error, onSelect, bi, testId } = param;
    var _options_find;
    const committed = value !== null && value !== void 0 ? value : '';
    const [optimistic, setOptimistic] = React.useState(null);
    const currentValue = React.useRef(committed);
    React.useEffect(()=>{
        currentValue.current = committed;
        setOptimistic(null);
    }, [
        committed
    ]);
    const display = optimistic !== null && optimistic !== void 0 ? optimistic : committed;
    const selectedOption = (_options_find = options.find((option)=>option.value === display)) !== null && _options_find !== void 0 ? _options_find : null;
    const disabledItems = options.filter((option)=>option.disabled === true).map((option)=>({
            id: option.value,
            tooltip: option.disabledTooltip
        }));
    const applyOptionChange = (option)=>{
        var _ref;
        const next = (_ref = option === null || option === void 0 ? void 0 : option.value) !== null && _ref !== void 0 ? _ref : '';
        if (next === currentValue.current) return;
        if ((option === null || option === void 0 ? void 0 : option.isAction) === true) {
            onSelect(next);
            return;
        }
        currentValue.current = next;
        setOptimistic(next);
        onSelect(next);
    };
    const renderOption = (option)=>{
        if (option.isAction) {
            return /*#__PURE__*/ _jsxs(Row, {
                alignItems: "center",
                gap: 6,
                children: [
                    /*#__PURE__*/ _jsx(Plus, {
                        size: INDICATOR_SIZE
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        as: "p",
                        skin: "link",
                        children: option.label
                    })
                ]
            });
        }
        if (option.subLabel == null) return option.label;
        return /*#__PURE__*/ _jsxs(Column, {
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    as: "p",
                    ellipsis: true,
                    children: option.label
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    as: "p",
                    skin: "secondary",
                    variant: "paragraph3",
                    ellipsis: true,
                    children: option.subLabel
                })
            ]
        });
    };
    return /*#__PURE__*/ _jsx(EnhancedAutocomplete, {
        bi: bi,
        testId: testId,
        style: {
            width: '100%'
        },
        options: [
            ...options
        ],
        keyField: "value",
        labelField: "label",
        selectedOption: selectedOption,
        disabled: disabled,
        disableClearable: disableClearable,
        virtualizeOptions: virtualizeOptions,
        error: error,
        disabledItems: disabledItems,
        itemRenderer: renderOption,
        getFilterText: (option)=>{
            var _option_filterText;
            return (_option_filterText = option.filterText) !== null && _option_filterText !== void 0 ? _option_filterText : option.label;
        },
        applyOptionChange: applyOptionChange,
        emptySearchText: emptySearchText,
        textFieldProps: {
            bi,
            placeholder
        },
        disableSort: true
    });
}
